import { Grid, Icon, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import AdminSidebar from "./Sidebar";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AnalyticsSharp, Dashboard, Delete, Pages, People, PeopleOutline, Settings, Visibility, VisibilityOff } from "@mui/icons-material";
import axios from 'axios';
export default function User() {
    var loc = useLocation();
    var navi = useNavigate();

    const [paths, setpaths] = useState([
        { Name: 'Dashboard', icon: <Dashboard sx={{ fontSize: 20 }} />, Path: '/Admin/Dashboard' },
        { Name: 'Customer', icon: <People sx={{ fontSize: 20 }} />, Path: '/Admin/Customer' },
        { Name: 'Clients', icon: <People sx={{ fontSize: 20 }} />, Path: '/Admin/Clients' },
        { Name: 'Users', icon: <People sx={{ fontSize: 20 }} />, Path: '/Admin/User' },
        { Name: 'Pages', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Pages' },
        { Name: 'Analytics', icon: <AnalyticsSharp sx={{ fontSize: 20 }} />, Path: '/Admin/Analytics' },
        { Name: 'Team', icon: <PeopleOutline sx={{ fontSize: 20 }} />, Path: '/Admin/Team' },
        { Name: 'Pages', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Pages' },
        { Name: 'Cities', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Cities' },
        { Name: 'Chat', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Chat' },
        { Name: 'Integration', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Integration' },
        { Name: 'Settings', icon: <Settings sx={{ fontSize: 20 }} />, Path: '/Admin/Settings' },
    ]);

    const [visible, setvisible] = useState(false);
    var url = `http://localhost:${process.env?.PORT || 3000}/`;
    function addMember(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        var id = data.get('id');
        var passoword = data.get('password');
        var role = data.get('role');
        try {
            axios.post(url + 'addMemberToPanel', {
                Id: id,
                Password: passoword,
                Role: role
            }).then((succ) => {
                if (succ.data.response == "failed") {
                    // alert('failed')
                    alert(succ.data.reason)
                } else {
                    alert('added');
                    getMembers();
                }
                e.target.reset();
                e.target.id.focus();
            })
        } catch (error) {
            alert('Network erorr. please check your network connection or try again later');
        }
    }

    const [admins, setadmins] = useState([]);
    function getMembers() {
        try {
            axios.post(url + 'getMembersToPanel').then((succ) => {
                if (succ.data.response == 'failed') {
                    alert(succ.data.reason);
                } else {
                    setadmins(succ.data.results);
                }
            })
        } catch (error) {
            alert('Network erorr. please check your network connection or try again later');
        }
    }
    useEffect(() => {
        getMembers();
    }, [])

    function deleteMember(id) {
        try {
            axios.post(url + 'deleteMemberToPanel', {
                Id: id
            }).then((succ) => {
                if (succ.data.response == 'failed') {
                    alert(succ.data.reason);
                } else {
                    getMembers();
                    // const myModal = bootstrap.Modal.getInstance(document.getElementById('confirm'));
                    // myModal.hide();
                }
            })
        } catch (error) {
            alert('Network erorr. please check your network connection or try again later')
        }
    }

    return (
        <>

            <Grid container spacing={0} sx={{ m: 0, width: '100%' }}>
                <AdminSidebar />
                <Grid container justifyContent={'space-around'} alignItems={'center'} size={{ xs: 12, lg: 10, }}>
                    <Grid size={{ lg: 4 }}>
                        <div className="card w-100 border-dark text-white">
                            <div className="card-body bg-admin-navy">
                                <Typography variant="h6">Add User</Typography>
                                <form onSubmit={addMember} className="mt-2">
                                    <input type="text" placeholder="User id" name="id" className="form-control form-controll border-dark" />
                                    <div className="input-group mt-2">
                                        <input type={visible ? 'text' : 'password'} name="password" placeholder="Password" className="form-control form-controll border-dark form-hovered" />
                                        <button type="button" onClick={() => setvisible(!visible)} className="btn btn-outline-light  btn-hovered">
                                            {visible ? <VisibilityOff color="inherit" /> : <Visibility color="inherit" />}
                                        </button>
                                    </div>
                                    <select name="role" className="form-select mt-2">
                                        <option value={'Admin'} selected>Admin</option>
                                        <option value={'User'}>User</option>
                                        <option value={'Editor'}>Editor</option>
                                        <option value={'Analyist'}>Analyist</option>
                                    </select>
                                    <button type="submit" className="btn-white mt-2">Add User</button>
                                </form>
                            </div>
                        </div>
                    </Grid>
                    <Grid size={{ lg: 6 }}>
                        <TableContainer sx={{ background: '#0F1536', color: 'white', borderRadius: 2 }}>
                            <Table aria-label="caption table">
                                {/* <caption>A basic table example with a caption</caption> */}
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="text-white">Id</TableCell>
                                        <TableCell className="text-white">Role</TableCell>
                                        <TableCell className="text-white">Password</TableCell>
                                        <TableCell className="text-white">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {admins.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell className="text-white" component="th" scope="row">
                                                {row.Id}
                                            </TableCell>
                                            <TableCell className="text-white">{row.Role}</TableCell>
                                            <TableCell className="text-white">**************</TableCell>
                                            <TableCell className="text-white">
                                                <IconButton color="inherit">
                                                    <Delete />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {/* <div className="card border-dark bg-admin-navy ">
                            <div className="card-body mt-2">
                                <table className="table  table-striped">
                                    <thead>
                                        <tr>
                                            <th align="center">Id</th>
                                            <th align="center">Role</th>
                                            <th align="center">Password</th>
                                            <th align="center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {admins.map((row, index) => (
                                            <tr key={index}>
                                                <th className="align-middle" align="right">
                                                 
                                                    {row.Id}
                                                    
                                                </th>
                                                <th className="align-middle" align="right">
                                                    
                                                    {row.Role}
                                                    
                                                </th>
                                                <th className="align-middle" align="right">
                                                    
                                                    ********
                                                    
                                                </th>
                                                <th className="align-middle" align="right">
                                                    
                                                    <IconButton data-bs-target={'#' + index} data-bs-toggle='modal' color="inherit">
                                                        <Delete />
                                                    </IconButton>
                                                    <div id={index} className="modal fade">
                                                        <div className="modal-dialog modal-md">
                                                            <div className="modal-content">
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <Typography variant="body1">Are you sure you want to delete this user?</Typography>
                                                                        <Grid container justifyContent={'space-between'} className='mt-3'>
                                                                            <button onClick={() => deleteMember(row._id)} className="btn-admin-navy col-lg-5">Confirm</button>
                                                                            <button data-bs-dismiss='modal' className="btn-outline-admin-navy col-lg-5">Cancel</button>
                                                                        </Grid>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                              
                                                </th>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div> */}
                    </Grid>
                </Grid>
            </Grid>

        </>
    )

}